import { Component, EventEmitter, Input, Output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';


@Component({
    selector: 'rating',
    templateUrl: './rating.component.html',
    styleUrls: ['./rating.component.less'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule]
})
export class RatingComponent {
  @Input() readonly = false;
  @Input() rating = 0;
  @Output() ratingChange = new EventEmitter();
  readonly possibleRatings = [5, 4, 3, 2, 1];
}
